module.exports = __webpack_public_path__ + "img/knu2_gallery9.4f8efcef.jpg";